import { useContext } from 'react';
import { FormSubmitStatusContext } from '../../context/FormSubmitStatusProvider';

export const useFormSubmitStatus = () => {
  const status = useContext(FormSubmitStatusContext);
  return Boolean(status.submitting);
};
